export default __webpack_public_path__ + "static/media/neraca6.11be48ba.png";